export const FIELDS_INSTRUCTIONS = {
    CAMPAIGN: {
        NAME: "Enter a short, catchy name that identifies your campaign (Max 100 characters).",
        DESCRIPTION: "Provide a brief overview of your campaign, including purpose, key messages, and target audience.",
        BRAND: "Choose the brand under which this campaign will be launched.",
        STRATEGY: "Choose if you wish to run a barter or a Paid Campaign.",
        BUDGET: "Enter the total budget allocated for this campaign.",
        LAUNCH_DATE: "Select the date when the campaign will go live.",
        INFLUENCER_GENDER: "Select the preferred gender of influencers for this campaign.",
        INFLUENCER_AGE: "Specify the age range of influencers you are looking to work with.",
        AUDIENCE_AGE: "Specify the target audience age for the campaign.",
        INFLUENCER_LOCATION: "Select the locations where influencers are based.",
        AUDIENCE_LOCATION: "Specify the target audience locations for the campaign.",
        NICHES: "Select the niches relevant to your campaign.",
        TOPICS: "Select the topics relevant to your campaign.",
        EXCLUDE_TOPICS: "Select the topics not relevant to your campaign.",
        MIN_INSTAGRAM_FOLLOWERS: "Enter the minimum number of Instagram followers required.",
        INFLUENCER_LANGUAGE: "Select the languages the influencer should have content in.",
        PER_INFLUENCER_BUDGET: "Enter the budget you are looking to allocate per influencer.",
        AUDIENCE_GENDER: "Specify the target audience gender for the campaign.",
        BARTER_BUDGET: "Enter the value of barter per influencer.",
        LANDING_PAGE_URL: "Enter the target link which will be used by influencers.",
        APPLICATION_RESTRICTION: "Set restrictions on who can apply to this campaign.",
        APPLICATION_RESTRICTION_DURATION: "Set duration for the application restriction.",
    },
    USER: {
        NAME: "Enter the full name of the user you wish to grant access to.",
        EMAIL: "Enter the email address of the user who will receive access and will be notified.",
        ROLE: "Select the user's role to define their access level, \n*Owner:* Full access, including settings and management,\n*Operations:* Limited access for managing campaigns and influencers,\n*Viewer:* Read-only access to view campaigns and reports.",
        BRANDS: "Select the brands of which you want to provide access to the user.",
        NOTIFICATION_PREFERENCES: "Select the events you want the user to receive notifications for."
    },
    BRAND: {
        LOGO: "Upload your brand's logo. Recommended size: 500x500 px. Accepted formats: JPG, PNG.",
        NAME: "Enter your brand's name. (Max 50 characters).",
        DESCRIPTION: "Provide a brief description of your brand, including its purpose and target audience.",
        WEBSITE: "Enter your brand's official website URL.",
        INSTAGRAM_HANDLE: "Provide your brand's official Instagram handle."
    }
};
